var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "topPoiTitle",
    style: _vm.titleStyle
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "poiName"
  }, [_vm._v(_vm._s(_vm.topPoiInfo.name || ''))]), _c('div', {
    staticClass: "position"
  }, [!_vm.topPoiInfo.is_remote ? _c('div', {
    ref: "distance",
    staticClass: "distance"
  }, [_vm._v(_vm._s(_vm.topPoiInfo.distance || ''))]) : _vm._e(), _c('div', {
    ref: "location",
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.topPoiInfo.addr || ''))])])]), _c('div', {
    staticClass: "rightBtn",
    on: {
      "click": function ($event) {
        return _vm.jumpToDetail(_vm.topPoiInfo.detailUrl);
      }
    }
  }, [_vm._v(" 看详情 ")]), _c('div', {
    staticClass: "topPoiTitle-bottom-line"
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };